export default function ArqAbout() {
  return (
    <section id="about" className="bg-arq-bg py-20 md:py-[120px] px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="arq-label mb-6">Who We Are</div>
        <h2
          className="font-display font-semibold text-arq-text mb-10 max-w-[900px]"
          style={{ fontSize: "clamp(28px, 4vw, 40px)", lineHeight: 1.2 }}
        >
          The Operational Security Practice Behind Enterprise AI.
        </h2>

        <div className="grid md:grid-cols-5 gap-12">
          <div className="md:col-span-3 space-y-5 text-arq-muted text-[17px] leading-[1.75]">
            <p>
              Most enterprises deploying AI already have capable product, platform, and
              security teams. What they lack is a dedicated practice for the layer where AI,
              applications, and autonomous workflows meet operational oversight.
            </p>
            <p className="text-arq-text">ArqeraAI was built for that layer.</p>
            <p>
              An engineering-led security and privacy practice. Founded by practitioners with
              10+ years of application security experience across healthcare, financial
              services, and logistics. CISSP, AWS, and Azure certified. Cloud-native,
              containerized, and on-premise architectures.
            </p>
            <p>
              We engineer the controls that sit between a finding and a fix. Our
              implementations hold up to engineering, audit, insurance, and board review.
            </p>
            <p>
              The outcome is straightforward: enterprise AI, deployed securely.
            </p>
          </div>

          <div className="md:col-span-2 space-y-5">
            <div className="arq-card p-8">
              <div className="font-display text-[28px] font-bold text-arq-text mb-2">10+ Years</div>
              <div className="text-arq-muted text-[14px] leading-[1.5]">
                Application security across enterprise and regulated environments
              </div>
            </div>
            <div className="arq-card p-8">
              <div className="font-display text-[28px] font-bold text-arq-text mb-2">Full Lifecycle</div>
              <div className="text-arq-muted text-[14px] leading-[1.5]">
                AppSec · AI security · Agentic & runtime governance · Privacy engineering · Continuous assurance
              </div>
            </div>
            <div className="arq-card p-8">
              <div className="font-display text-[28px] font-bold text-arq-text mb-2">CISSP · AWS · Azure</div>
              <div className="text-arq-muted text-[14px] leading-[1.5]">
                Engineering-led practitioners with certifications across cloud and security
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

